module.exports = __webpack_public_path__ + "static/media/EventPhoto5.09afad6c.jpg";